import { API_BASE } from '../../../config/api';

const authHeaders = (token) => ({ Authorization: `Bearer ${token}` });

const handleResponse = async (response, fallback = 'Unable to load super admin data.') => {
  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw new Error(data.error || data.message || fallback);
  }

  return data;
};

const fetchEntityList = async (path, { token, view = 'active' }) => {
  const response = await fetch(`${API_BASE}${path}?view=${view}`, {
    headers: authHeaders(token),
  });

  return handleResponse(response);
};

export const fetchSaOrganizations = ({ token, view = 'active' }) =>
  fetchEntityList('/api/sa/organizations', { token, view });

export const fetchSaClubs = ({ token, view = 'active' }) =>
  fetchEntityList('/api/sa/clubs', { token, view });

export const fetchSaCommunities = ({ token, view = 'active' }) =>
  fetchEntityList('/api/sa/communities', { token, view });

export const fetchSaIndividuals = ({ token, view = 'active' }) =>
  fetchEntityList('/api/sa/users', { token, view });
